import { useState } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

const items = [
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/w_600/VantageFit/NewWebsite/Playbook_new1.png',
    altText: 'Host exciting wellness contests with the flexibility to modify them to spice things up.',
    caption: 'Create and Customize Contest and Challenges',
    imagealtText:'corporate wellness platform'
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/w_600/VantageFit/NewWebsite/Playbook_new2.png',
    altText: 'Get valuable insights into your wellness campaigns with advanced analytics and reports.',
    caption: 'Real-time Insights and Reports',
    imagealtText:'Employee health'
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/w_600/VantageFit/NewWebsite/Playbook_3.png',
    altText: 'Allocate and manage the budget for your wellness contests as per your organizational requirements.',
    caption: 'Budget Management',
    imagealtText:'office health competitions'
  }
];

const CorporateWellnessGuideCarousel = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
      <div className="row ">
      <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 pclr text-center">
      <img src={item.src} alt={item.imagealtText} className="img_shadow max-w" width="530" height="387"/>
      </div> </div>   

      </CarouselItem>
    );
  });

  return (
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
    >
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} className="commonindicator"/>
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </Carousel>
  );
}

export default CorporateWellnessGuideCarousel;



